import { axiosAuth } from "./axios";
import { API_PATHS } from "./constants";

export const issueAccounts = async (name) => {
  const result = await axiosAuth.post(API_PATHS.CREATE_ACCOUNT, name);

  return result;
};
